export default {"src":"/_next/static/media/towels_provided.bca8c1b0.svg","height":100,"width":100};